import type { RouteObject } from 'react-router-dom';
import { RoleGuard } from '@/shared/guards/RoleGuard';
import { PENDING_ALERTS_ROLES } from '../registry/sources';
import { PendingAlertsPage } from './pages/PendingAlertsPage';

/**
 * Gateado pela união dos papéis de todas as fontes registradas
 * (`PENDING_ALERTS_ROLES`) — entrar na tela não garante ver todas as fontes;
 * cada uma segue gateada por si mesma no fetch (ver `use-pending-alerts.ts`).
 */
export const pendingAlertsRoutes: RouteObject[] = [
  {
    element: <RoleGuard roles={PENDING_ALERTS_ROLES} />,
    children: [{ path: 'pending-alerts', element: <PendingAlertsPage /> }],
  },
];
